enum ProfileCountries {
  USA = "USA",
  CANADA = "Canada",
}

export default ProfileCountries;